import Vue from 'vue';
import URI from 'urijs';
import { notNullOrUndefined } from '@/helper/notNullOrUndefined';
export const PartSearchPagination = Vue.extend({
    functional: true,
    props: {
        numberOfPages: Number,
        currentPageNumber: Number,
        baseSearchLink: String,
    },
    render(h, ctx) {
        if (!ctx.props.numberOfPages || ctx.props.numberOfPages <= 1) {
            return <div />;
        }
        return (<nav class="row">
                <div class="col-12 d-flex justify-content-center">
                    <ul class="pagination part-search__pagination mt-2">
                        {buildPaginationItems(h, ctx.props.numberOfPages, ctx.props.currentPageNumber, ctx.props.baseSearchLink)}
                    </ul>
                </div>
            </nav>);
    },
});
function buildPaginationItems(h, numberOfPages, currentPageNumber, baseSearchLink) {
    return [...Array(numberOfPages).keys()]
        .map((index) => {
        const pageNumber = index + 1;
        return buildPaginationItem(h, numberOfPages, currentPageNumber, pageNumber, baseSearchLink);
    })
        .filter(notNullOrUndefined);
}
function buildPaginationItem(h, numberOfPages, currentPageNumber, pageNumber, baseSearchLink) {
    if (pageNumber < 4 ||
        (currentPageNumber - 2 <= pageNumber &&
            currentPageNumber + 2 >= pageNumber) ||
        pageNumber > numberOfPages - 3) {
        return (<li class={`page-item part-search__pagination-item ${pageNumber === currentPageNumber ? 'active' : ''}`}>
                <a class="page-link part-search__pagination-link" href={buildSearchLinkForPage(baseSearchLink, pageNumber)}>
                    {pageNumber}
                </a>
            </li>);
    }
    else if (pageNumber === currentPageNumber - 3 ||
        pageNumber === currentPageNumber + 3) {
        return (<li class="page-item disabled" tabindex="-1">
                <a class="page-link" href="#">
                    &hellip;
                </a>
            </li>);
    }
    return null;
}
function buildSearchLinkForPage(baseSearchLink, pageNumber) {
    return new URI(baseSearchLink).addQuery({ pageNumber }).toString();
}
//# sourceMappingURL=PartSearchPagination.jsx.map